import {
  AnalyticsEvent,
  type AutocompleteSuggestionSelected,
  type SearchSuggestionsViewed,
} from '@shipt/analytics-member-web'
import { urlPathnameToLocationName } from '@/features/shared/analytics/utils'
import { track } from '@/features/shared/analytics/trackingQueue'

export type AutocompleteClickLabel =
  | 'erased'
  | 'entered'
  | 'suggestion_clicked'
  | 'image_suggestion_clicked'

export const trackAutocompleteSuggestionSelected = (
  eventProperties: AutocompleteSuggestionSelected['properties'],
) =>
  track({
    eventName: AnalyticsEvent.AutocompleteSuggestionSelected,
    properties: eventProperties,
  })

export const trackSearchSuggestionsViewed = (
  eventProperties: Omit<SearchSuggestionsViewed['properties'], 'location' | 'click_label'> & {
    click_label: AutocompleteClickLabel
  },
) =>
  track({
    eventName: AnalyticsEvent.SearchSuggestionsViewed,
    properties: { ...eventProperties, location: urlPathnameToLocationName() },
  })
